/* eslint-disable no-mixed-spaces-and-tabs */
import React from 'react';
import { useEffect, useState } from 'react';
import { insertImpatto } from '../reduxStore/questCorrenteSlice'

import PropTypes from 'prop-types';
import { useForm, Controller } from 'react-hook-form';
import { Form } from 'react-bootstrap';
import { useSelector } from 'react-redux'
import { useDispatch } from 'react-redux'

// import {FalconComponentCard} from 'components/common/FalconComponentCard';
// import {FalconReactRange} from './FalconReactRange';
// import {FalconEditor} from 'components/common/FalconEditor';

import { CompilaQuestionarioImpatti } from './CompilaQuestionarioImpatti.js';
import FalconCloseButton from 'components/common/FalconCloseButton';

import { Button, Card, Modal } from 'react-bootstrap';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { Link } from 'react-router-dom';
// import { faHome } from '@fortawesome/free-solid-svg-icons';
// import { Range, getTrackBackground, FalconReactRange } from "../..index/index";

export const CompilaQuestionarioWrapperImpatti = (props) => {
  console.log ("CompilaQuestionarioWrapperImpatti - props: ",props)

  const questionarioCorrente = useSelector((state) => state.questCorrente);

  const numeroAzioniMitigazione = [
    { id: 1, nome:'1' },
    { id: 2, nome:'2' }
  ]

  // Estraggo Array stakeholders filtrato
  const excludedIds = ['AZ', 'CT'];
  const stakeholdersFiltered = questionarioCorrente.stakeholders.filter(stakeholder => !excludedIds.includes(stakeholder.id));

  const csvcConti = [
    { id:'A1', nome:'A.1 - TOTALE VALORE DELLA PRODUZIONE - Principali' },
    { id:'A2', nome:'A.2 - TOTALE VALORE DELLA PRODUZIONE - Altri' },
    { id:'B1', nome:'B.1 - TOTALE COSTI INTERM. DELLA PROD. - Consumi materie prime' },
    { id:'B2', nome:'B.2 - TOTALE COSTI INTERM. DELLA PROD. - Consumi materie sussidiarie' },
    { id:'B3', nome:'B.3 - TOTALE COSTI INTERM. DELLA PROD. - Costi per servizi' },
    { id:'B4', nome:'B.4 - TOTALE COSTI INTERM. DELLA PROD. - Costi godimento beni di terzi' },
    { id:'B5', nome:'B.5 - TOTALE COSTI INTERM. DELLA PROD. - Accantonamento rischi vari' },
    { id:'B6', nome:'B.6 - TOTALE COSTI INTERM. DELLA PROD. - Oneri diversi di gestione' },
    { id:'B7', nome:'B.7 - TOTALE COSTI INTERM. DELLA PROD. - Personale non dipendente' },
    { id:'C1', nome:'C.1 - TOTALE GESTIONE STRAORDINARIA - Ricavi accessori' },
    { id:'C2', nome:'C.2 - TOTALE GESTIONE STRAORDINARIA - Costi/ricavi straordinari' },
    { id:'C3', nome:'C.3 - TOTALE GESTIONE STRAORDINARIA - Ammortamenti della gestione' },
    { id:'E1', nome:'E.1 - TOTALE REMUNERAZIONE PERSONALE - Personale dipendente' },
    { id:'F1', nome:'F.1 - TOTALE REMUNERAZIONE P.A.  - Remunerazione pubblica amministrazione' },
    { id:'G1', nome:'G.1 - TOTALE REMUNERAZIONE CAPITALE DI CREDITO - Remunerazione capitale di credito' },
    { id:'H1', nome:'H.1 - TOTALE LIBERALITÀ ESTERNE - Liberalità esterne' },
    { id:'L1', nome:'L.1 - TOTALE COSTI DIVERSI - Costi diversi' }
  ]

    // --- START GESTIONE STATO MODAL ModalToRiskRedefine ---------------------------
    const [modalNewRiskDefineShow, setModalNewRiskDefineShow] = React.useState(false);
    const [showAzione2Fields, setShowAzione2Fields] = useState(true);

    // const handleOpenModalToRiskRedefine = () =>  setModalNewRiskDefineShow(true)
    const handleCloseModalToRiskRedefine = () => setModalNewRiskDefineShow(false);
    // --- END GESTIONE STATO MODAL ModalToRiskRedefine ---------------------------

   
    // ----------------------------------------------------------
    //  INIZIO GESTIONE PER react-hook-form
    const { control, register, setValue,  handleSubmit, formState: { errors }, watch } = useForm();
    const impatto_numeroAzioniMitigazioneDaInserire = watch('impatto_numeroAzioniMitigazioneDaInserire');

    //  Inizializzo valori di default: 
    useEffect(() => {
        setValue('impatto_soggettoImpattato', 'CO');
    }, [setValue]);

    useEffect(() => {
        setValue('impatto_numeroAzioniMitigazioneDaInserire', 1);
    }, [setValue]);


    useEffect(() => {
        setValue('azione_1_opport_azienda_conto', 'A1');
    }, [setValue]);

    useEffect(() => {
        setValue('azione_2_opport_azienda_conto', 'A1');
    }, [setValue]);


    useEffect(() => {
        setValue('azione_1_costi_azienda_conto', 'A1');
    }, [setValue]);

    useEffect(() => {
        setValue('azione_2_costi_azienda_conto', 'A1');
    }, [setValue]);


    useEffect(() => {
        setValue('azione_1_contributi_azienda_conto', 'A1');
    }, [setValue]);

    useEffect(() => {
        setValue('azione_2_contributi_azienda_conto', 'A1');
    }, [setValue]);


    useEffect(() => {
        setValue('azione_2_descrizione', '.');
    }, [setValue]);

    useEffect(() => {
        setValue('azione_2_opport_stakeholder_descrizione', '.');
    }, [setValue]);

    useEffect(() => {
        setValue('azione_2_opport_azienda_descrizione', '.');
    }, [setValue]);




    useEffect(() => {
        setShowAzione2Fields(impatto_numeroAzioniMitigazioneDaInserire === '2');
    }, [impatto_numeroAzioniMitigazioneDaInserire]);



    const dispatch = useDispatch();

    const onReactHookFormSubmit = (data) => {
        const updatedValues = {
            questionarioUuid: questionarioCorrente.questionarioUuid, 
            ...data
        }

        console.log('**## onReactHookFormSubmit - updatedValues: ', updatedValues)
        dispatch(insertImpatto(updatedValues))
        setModalNewRiskDefineShow(false);
    };

    //  FINE GESTIONE PER react-hook-form
    // ----------------------------------------------------------



    if (props.impatti.length>0) {
        return (<CompilaQuestionarioImpatti impatti={props.impatti} />)     
    }
    else {
        // return (<CompilaQuestionarioImpatti impatti={props.impatti} />)     
        return (<>     
            <Card key={props.ricaduta.key} className="bg-100 shadow-none border mb-3" style={{marginBottom:"2%"}}>
                <Card.Body>
                    <Card.Title style={{marginBottom:"3%"}}>
                        <h1 className="text-danger fs-10 mb-0"> <span className="text-danger  fw-medium">Rischio NON DEFINITO per ricaduta </span> <strong>{props.ricaduta.effetto}</strong> 
                            <span className="text-danger  fw-medium"><i>({props.ricaduta.tipo})</i></span></h1>
                    </Card.Title>
                    <Card.Text>
                    <Button variant={'primary'}  onClick={()=>{
                        //    setImpattoToRedefine({impattoToRedefineKey:impatto.key} )
                            setModalNewRiskDefineShow(true)
                        }}>
                        Definisci un nuovo rischio
                    </Button>                
                    </Card.Text>
                </Card.Body>
            </Card>
            


            <Modal size="lg" show={modalNewRiskDefineShow} onHide={handleCloseModalToRiskRedefine} backdrop="static" keyboard={false}>
            <Form onSubmit={handleSubmit(onReactHookFormSubmit)}>

		<Modal.Header>
			<Modal.Title>Definisci un nuovo rischio per {props.ricaduta.key.substring(0, 7)} - Ricaduta {props.ricaduta.codiceCsvc}</Modal.Title>
			<FalconCloseButton onClick={handleCloseModalToRiskRedefine} />
		</Modal.Header>


        <Modal.Body>
			<Controller
                name="ricaduta"
                control={control}
                defaultValue={props.ricaduta.key}
                render={({ field }) => (
                <input type="hidden" {...field} />
			  )}
			/>
            
            <Form.Group controlId="impatto_descrizione" style={{marginTop:"2%"}}>
                <Form.Label>Descrizione del rischio (obbligatorio)</Form.Label>
                <Controller
                name="impatto_descrizione"
                {...register('impatto_descrizione', { required:true})}
                control={control}
                defaultValue=""
                render={({ field }) => <Form.Control type="text" placeholder="Inserisci la descrizione del rischio" {...field} />}
                />
                {errors.impatto_descrizione && <span style={{color:"red"}}>Questo campo è obbligatorio</span>}
            </Form.Group>

            <Form.Group controlId="impatto_soggettoImpattato" style={{marginTop:"2%"}}>
                <Form.Label>Stakehoder impattato (obbligatorio)</Form.Label>
                <Controller
                    name="impatto_soggettoImpattato"
                    control={control}
                    render={({ field }) => (
                        <Form.Control as="select" {...field}>
                            {stakeholdersFiltered.map(stakeholder => (
                                <option key={stakeholder.id} value={stakeholder.id}>
                                    {stakeholder.alias}
                                </option>
                            ))}
                        </Form.Control>
                    )}
                />
            </Form.Group>

            <Form.Group controlId="impatto_numeroAzioniMitigazioneDaInserire" style={{marginTop:"2%"}}>
                <Form.Label>Numero azioni di mitigazione da inserire </Form.Label>
                <Controller
                    name="impatto_numeroAzioniMitigazioneDaInserire"
                    control={control}
                    render={({ field }) => (
                        <Form.Control as="select" {...field}>
                            {numeroAzioniMitigazione.map(numeroAzione => (
                                <option key={numeroAzione.id} value={numeroAzione.id}>
                                    {numeroAzione.nome}
                                </option>
                            ))}
                        </Form.Control>
                    )}
                />
            </Form.Group>

            <hr />

            <Form.Group controlId="azione_1_descrizione" style={{marginTop:"2%"}}>
                <Form.Label>Descrizione azione di mitigazione N. 1 </Form.Label>
                <Controller
                name="azione_1_descrizione"
                {...register('azione_1_descrizione', { required:true})}
                control={control}
                defaultValue=""
                render={({ field }) => <Form.Control type="text" placeholder="Inserisci la descrizione della prima azione di mitigazione" {...field} />}
                />
                {errors.azione_1_descrizione && <span style={{color:"red"}}>Questo campo è obbligatorio</span>}
            </Form.Group>


            <Form.Group controlId="azione_1_opport_stakeholder_descrizione" style={{marginTop:"2%"}}>
                <Form.Label>Descrizione opportunita per stakeholder (azione N. 1) </Form.Label>
                <Controller
                name="azione_1_opport_stakeholder_descrizione"
                {...register('azione_1_opport_stakeholder_descrizione', { required:true})}
                control={control}
                defaultValue=""
                render={({ field }) => <Form.Control type="text" placeholder="Inserisci la descrizione della opportunita per stakeholder della prima azione" {...field} />}
                />
                {errors.azione_1_opport_stakeholder_descrizione && <span style={{color:"red"}}>Questo campo è obbligatorio</span>}
            </Form.Group>


            <Form.Group controlId="azione_1_opport_azienda_descrizione" style={{marginTop:"2%"}}>
                <Form.Label>Descrizione opportunità per azienda (azione N. 1) </Form.Label>
                <Controller
                name="azione_1_opport_azienda_descrizione"
                {...register('azione_1_opport_azienda_descrizione', { required:true})}
                control={control}
                defaultValue=""
                render={({ field }) => <Form.Control type="text" placeholder="Inserisci la descrizione della opportunita per azienda della prima azione" {...field} />}
                />
                {errors.azione_1_opport_stakeholder_descrizione && <span style={{color:"red"}}>Questo campo è obbligatorio</span>}
            </Form.Group>


            <Form.Group controlId="azione_1_opport_azienda_conto" style={{marginTop:"2%"}}>
                <Form.Label>Conto opportunità per azienda (azione N. 1) </Form.Label>
                <Controller
                    name="azione_1_opport_azienda_conto"
                    control={control}
                    render={({ field }) => (
                        <Form.Control as="select" {...field}>
                            {csvcConti.map(conto => (
                                <option key={conto.id} value={conto.id}>
                                    {conto.nome}
                                </option>
                            ))}
                        </Form.Control>
                    )}
                />
            </Form.Group>

            <Form.Group controlId="azione_1_costi_azienda_conto" style={{marginTop:"2%"}}>
                <Form.Label>Conto costi per azienda (azione N. 1) </Form.Label>
                <Controller
                    name="azione_1_costi_azienda_conto"
                    control={control}
                    render={({ field }) => (
                        <Form.Control as="select" {...field}>
                            {csvcConti.map(conto => (
                                <option key={conto.id} value={conto.id}>
                                    {conto.nome}
                                </option>
                            ))}
                        </Form.Control>
                    )}
                />
            </Form.Group>

            <Form.Group controlId="azione_1_contributi_azienda_conto" style={{marginTop:"2%"}}>
                <Form.Label>Conto contributi per azienda (azione N. 1) </Form.Label>
                <Controller
                    name="azione_1_contributi_azienda_conto"
                    control={control}
                    render={({ field }) => (
                        <Form.Control as="select" {...field}>
                            {csvcConti.map(conto => (
                                <option key={conto.id} value={conto.id}>
                                    {conto.nome}
                                </option>
                            ))}
                        </Form.Control>
                    )}
                />
            </Form.Group>

            <hr />
        {showAzione2Fields && (
            <>

            <Form.Group controlId="azione_2_descrizione" style={{marginTop:"2%"}}>
                <Form.Label>Descrizione azione di mitigazione N. 2 </Form.Label>
                <Controller
                name="azione_2_descrizione"
                control={control}
                defaultValue=""
                render={({ field }) => <Form.Control type="text" placeholder="Inserisci la descrizione della seconda azione di mitigazione" {...field} />}
                />
                {errors.azione_2_descrizione && <span style={{color:"red"}}>Questo campo è obbligatorio</span>}
            </Form.Group>


            <Form.Group controlId="azione_2_opport_stakeholder_descrizione" style={{marginTop:"2%"}}>
                <Form.Label>Descrizione opportunita per stakeholder (azione N. 2) </Form.Label>
                <Controller
                name="azione_2_opport_stakeholder_descrizione"
                control={control}
                defaultValue=""
                render={({ field }) => <Form.Control type="text" placeholder="Inserisci la descrizione della opportunita per stakeholder della seconda azione" {...field} />}
                />
                {errors.azione_2_opport_stakeholder_descrizione && <span style={{color:"red"}}>Questo campo è obbligatorio</span>}
            </Form.Group>


            <Form.Group controlId="azione_2_opport_azienda_descrizione" style={{marginTop:"2%"}}>
                <Form.Label>Descrizione opportunità per azienda (azione N. 2) </Form.Label>
                <Controller
                name="azione_2_opport_azienda_descrizione"
                control={control}
                defaultValue=""
                render={({ field }) => <Form.Control type="text" placeholder="Inserisci la descrizione della opportunita per azienda della seconda azione" {...field} />}
                />
                {errors.azione_2_opport_azienda_descrizione && <span style={{color:"red"}}>Questo campo è obbligatorio</span>}
            </Form.Group>


            <Form.Group controlId="azione_2_opport_azienda_conto" style={{marginTop:"2%"}}>
                <Form.Label>Conto opportunità per azienda (azione N. 2) </Form.Label>
                <Controller
                name="azione_2_opport_azienda_conto"
                control={control}
                render={({ field }) => (
                    <Form.Control as="select" {...field}>
                        {csvcConti.map(conto => (
                            <option key={conto.id} value={conto.id}>
                                {conto.nome}
                            </option>
                        ))}
                    </Form.Control>
                )}
            />
        </Form.Group>

        <Form.Group controlId="azione_2_costi_azienda_conto" style={{marginTop:"2%"}}>
            <Form.Label>Conto costi per azienda (azione N. 2) </Form.Label>
            <Controller
                name="azione_2_costi_azienda_conto"
                control={control}
                render={({ field }) => (
                    <Form.Control as="select" {...field}>
                        {csvcConti.map(conto => (
                            <option key={conto.id} value={conto.id}>
                                {conto.nome}
                            </option>
                        ))}
                    </Form.Control>
                )}
            />
        </Form.Group>

        <Form.Group controlId="azione_2_contributi_azienda_conto" style={{marginTop:"2%"}}>
            <Form.Label>Conto contributi per azienda (azione N. 2) </Form.Label>
            <Controller
                name="azione_2_contributi_azienda_conto"
                control={control}
                render={({ field }) => (
                    <Form.Control as="select" {...field}>
                        {csvcConti.map(conto => (
                            <option key={conto.id} value={conto.id}>
                                {conto.nome}
                            </option>
                        ))}
                    </Form.Control>
                )}
            />
        </Form.Group>

        </>
        )}

        </Modal.Body>
		
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseModalToRiskRedefine}>
            Annulla
          </Button>
          <Button variant="primary" type="submit">Invia</Button>
        </Modal.Footer>
		
      </Form>

    </Modal>
    </>)
    }
};



CompilaQuestionarioWrapperImpatti.propTypes = {
    impatti: PropTypes.array,
    ricaduta: PropTypes.object
};

/*

                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCloseModalToRiskRedefine}>
                        Annulla
                    </Button>
                </Modal.Footer>



*/